import React, { useEffect, useCallback, useState} from 'react';
import AlternateThumbnails from './AlternateThumbnails.js';
import Royalties from './Royalties.js';
import ImageHandler from 'components/explore/lists/ImageHandler.js';
import ZoraField from './ZoraField.js';
import {connect} from 'react-redux';
import './zora.scss';

/**
 * 
 * UI for setting bidshares, description, name
 * and thumbnail for mint to zora
 */
const ZoraMintConfiguration = ({
    name,
    description,
    royalties,
    thumbnail,
    setName,
    setDescription,
    setThumbnail,
    alternateThumbnails
}) => { 
    return (
        <div className="zora-configuration">
          <ZoraField set={setName} get={name} name="name"/>
          <ZoraField set={setDescription} get={description} name="description" isTextArea={true}/>
          <AlternateThumbnails selected={thumbnail} setThumbnail={setThumbnail} thumbnails={alternateThumbnails}/>
          <ImageHandler placeholder="Drop the thumbnail image for your work, here" imageHash={thumbnail} setImageHash={setThumbnail}/>
          <Royalties royalties={royalties}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoraMintConfiguration);
